<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <mt-header title="公务用车申请单">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div style="width: 21rem; ">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="申请人" readonly/>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="destination" label="目的地"/>
        </div>
        <mt-cell label="开始日期" @click.native="selectStartTime">
          <div style="font-size: 1.2rem;color: black;">{{ startTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!startTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearStartTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <mt-cell label="结束日期" @click.native="selectEndTime">
          <div style="font-size: 1.2rem;color: black;">{{ endTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!endTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearEndTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="procseeDays" type="number" label="乘车人数"/>
        </div>
        <van-field name="uploader"
                   label="审核人员"
                   v-if="roleId!=12">
          <template #input>
            <div style="color: black;">{{nameuser}}</div>
          </template>
        </van-field>
        <van-field name="uploader" label="附件">
          <template #input>
            <div  class="btn btn-default"style="position: relative; overflow: hidden;
              margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute;
               top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in fileList"
                  :key="idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item.attachmentName }}</span><div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <van-field
            label="用车事由"
            class="owntext"
            v-model="processDescribe"
            rows="2"
            autosize
            type="textarea"
            placeholder="请输入用车事由"
            show-word-limit
        />
        <van-field name="uploader"
                   label="分管领导审批"
                   v-if="roleId==12">
          <template #input>
            <div @click.prevent="isFgVisible=true" style="color: black;">
              {{isFgName}}
              <i class="mintui mintui-field-error"></i>
            </div>
          </template>
        </van-field>

        <div v-if="roleId==12">
          <div  v-if="isRes==0" style="display: flex; gap: 8px;">
            <div class="sub" @click.prevent="liuzhuanSubmit">审核并流转</div>
            <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
          </div>
          <div v-else style="display: flex; gap: 8px;">
            <div  class="sub" @click.prevent="jieanSubmit">审核并结案</div>
            <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
          </div>
        </div>
        <div v-else style="display: flex; gap: 8px;">
          <div  class="sub" @click.prevent="handelSubmit">提交</div>
          <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
        </div>
      </div>
    </div>
    <!-- 是否需要分管领导审批选择 -->
    <mt-popup
        style="width: 100%"
        v-model="isFgVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="isFgVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectIsFgPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="isFgList"
          ref="isFgList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
    <!-- 开始时间选择 -->
    <van-popup  v-model="startTimeVisible" position="bottom" style="width: 100%;height: 50%;font-size: 200px">
      <van-datetime-picker
          type="datetime"
          title="选择用车开始时间"
          v-model="currentStartDate"
          :min-date="minDate"
          @confirm="onStartTimeConfirm"
          @cancel="startTimeVisible = false"
      />
    </van-popup>
    <!-- 结束时间选择 -->
    <van-popup  v-model="endTimeVisible" position="bottom" style="width: 100%;height: 50%;">
      <van-datetime-picker
          v-model="currentEndDate"
          type="datetime"
          title="选择用车结束时间"
          @confirm="onEndTimeConfirm"
          @cancel="endTimeVisible = false"
      />
    </van-popup>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      isRes:0,
      isFgName: "是",
      isFgList:[
        {
          values: [
            {
              code: "0",
              name: "是"
            },
            {
              code: "1",
              name: "否"
            }
          ],
          className: "slot1"
        }
      ],
      isFgVisible: false,
      fileList: [],
      fileIds: [],
      minDate: new Date(2024, 11, 1),
      currentStartDate: new Date(),
      currentEndDate: new Date(),
      processDescribe: "",
      userName: "",
      destination: "",
      userId:"",
      isLoading: false,
      nameuser: null,//审核人姓名
      userInfo:{},
      startTime:'',			//流程开始时间
      endTime:'',//流程结束时间
      procseeDays:'', //乘车人数
      startTimeVisible:false,
      endTimeVisible:false,
      roleId:'',
      route:'',
      item:{},
      processId:'',
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.userName = this.userInfo.userName
    this.userId = this.userInfo.userId
    console.log(this.userInfo.dept.deptmanager)
    if(this.userId==this.userInfo.dept.deptmanager){
      await request({
        url: "getOfficeName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }else {
      await request({
        url: "getManagerName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }
    request({
      url: "appFindRoleId?userId="+this.userId,
      method: "get"
    }).then(  response => {
        this.roleId = response
    })
    this.startTime =this.formatDate(new Date())
    this.endTime = this.formatDate(new Date())
    this.processId = this.$route.query.item==undefined?'':this.$route.query.item.processId
    if(this.processId){
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehiclesDetail?processId="+this.processId,
        method: "get",
      }).then(response => {
        this.item = response.data
        console.log(this.item)
        this.isRes= this.item.isRes
        this.isFgName = this.isRes==0?'是':'否'
        this.destination = this.item.destination  //请假类型
        this.holidayTypeName = this.item.holidayTypeName;
        this.procseeDays = this.item.procseeDays, //请假天数
        this.processDescribe = this.item.processDescribe,	//流程申请原因内容
        this.startTime = this.item.startTime,			//流程开始时间
        this.endTime = this.item.endTime,			//流程结束时间
        this.fileIds = this.item.proFileid.split(",")
        if(this.item.proFileid){
          request({
            url: "appDocumentFile?fileIds="+this.item.proFileid,
            method: "get"
          }).then(  response => {
            response.forEach(file => {
              this.fileList.push(file)
            });
          })
        }
      })
    }
    this.route =  this.$route.query.route
  },
  watch: {
  },
  methods: {
    selectIsFgPicker(){
      this.isRes = this.$refs.isFgList.getValues()[0].code;
      console.log(this.isRes)
      this.isFgName =  this.$refs.isFgList.getValues()[0].name;
      this.isFgVisible = false;
    },
    fileListChange(event){
      const file = event.target.files[0]
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSavePfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file:file,userId:this.userId}
      }).then(  response => {
        this.fileList.push(response.data)
        this.fileIds.push(response.data.attachmentId)
      })
    },
    fileListdel(attachment){
      this.fileList.splice(this.fileList.indexOf(attachment),1)
      this.fileIds.splice(this.fileIds.indexOf(attachment.attachmentId),1)
    },
    selectStartTime() {
      this.startTimeVisible = true;
    },
    onStartTimeConfirm(value) {
      this.startTime = this.formatDate(value);
      if(new Date(this.endTime).getTime()<new Date(this.startTime).getTime()){
        this.startTimeVisible = true
        Toast({
          message: "开始时间大于结束时间了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        this.startTimeVisible = false
      }
    },
    // 清除时间
    clearStartTime() {
      if (this.startTime) {
        this.startTime = '';
      }
    },
    selectEndTime() {
      this.endTimeVisible = true;
    },
    onEndTimeConfirm(value) {
      this.endTime = this.formatDate(value);
      if(new Date(this.endTime).getTime()<new Date(this.startTime).getTime()){
        this.endTimeVisible = true
        Toast({
          message: "结束时间小于开始时间了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        this.endTimeVisible = false
      }
    },
    // 清除时间
    clearEndTime() {
      if (this.endTime) {
        this.endTime = '';
      }
    },
    formatDate(timestamp) {
      // 创建一个新的Date对象，使用时间戳初始化
      const date = new Date(timestamp);

      // 获取各个时间组件
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 组合成所需的格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async jieanSubmit() {
      if (!this.destination) {
        Toast({
          message: "请填写目的地"
        });
        return;
      }
      if (!this.procseeDays) {
        Toast({
          message: "请填写乘车人数"
        });
        return;
      }
      if (!this.processDescribe) {
        Toast({
          message: "请填写用车事由"
        });
        return;
      }
      let params = {
        processId : this.processId,
        userId : this.userId,			//流程申请人
        destination:this.destination,//目的地
        startTime : this.startTime,			//流程开始时间
        endTime : this.endTime,			//流程结束时间
        procseeDays : this.procseeDays, //乘车人数
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        isRes:this.isRes
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehiclesOfficejie",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "新增成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    async liuzhuanSubmit() {
      if (!this.destination) {
        Toast({
          message: "请填写目的地"
        });
        return;
      }
      if (!this.procseeDays) {
        Toast({
          message: "请填写乘车人数"
        });
        return;
      }
      if (!this.processDescribe) {
        Toast({
          message: "请填写用车事由"
        });
        return;
      }
      let params = {
        processId : this.processId,
        userId : this.userId,			//流程申请人
        destination:this.destination,//目的地
        startTime : this.startTime,			//流程开始时间
        endTime : this.endTime,			//流程结束时间
        procseeDays : this.procseeDays, //乘车人数
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        isRes:this.isRes
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehiclesOfficeliu",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "新增成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    caogaoSubmit() {
      if (!this.destination) {
        Toast({
          message: "请填写目的地"
        });
        return;
      }
      if (!this.procseeDays) {
        Toast({
          message: "请填写乘车人数"
        });
        return;
      }
      if (!this.processDescribe) {
        Toast({
          message: "请填写用车事由"
        });
        return;
      }
      let params = {
        processId : this.processId,
        userId : this.userId,			//流程申请人
        destination:this.destination,//目的地
        startTime : this.startTime,			//流程开始时间
        endTime : this.endTime,			//流程结束时间
        procseeDays : this.procseeDays, //乘车人数
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        statusId:22,
        isRes:this.isRes
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehicles",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "保存草稿成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
     handelSubmit() {
      if (!this.destination) {
        Toast({
          message: "请填写目的地"
        });
        return;
      }
      if (!this.procseeDays) {
        Toast({
          message: "请填写乘车人数"
        });
        return;
      }
      if (!this.processDescribe) {
        Toast({
          message: "请填写用车事由"
        });
        return;
      }
      let params = {
        processId : this.processId,
        userId : this.userId,			//流程申请人
        destination:this.destination,//目的地
        startTime : this.startTime,			//流程开始时间
        endTime : this.endTime,			//流程结束时间
        procseeDays : this.procseeDays, //乘车人数
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        statusId:23
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehicles",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "提交成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    goBack() {
      this.$router.push(this.route==undefined?"/procedure/addProcedure":this.route);
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.van-field__control {
  line-height:  2rem;
  font-size: 1.5rem !important;
  margin-top: 10px;
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 50px;
}
.van-field__label {
  span{
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb
  }
  width: 8.2rem;
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.van-field__value {
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.userinfoAdd {
  .idea {
    height: 2.466667rem;
    line-height: 2.466667rem;
    font-size: 1rem;
    background: #efefef;
    color: #646566;
    text-align: center;
    margin-bottom: 0.4rem;
    margin: 0.5rem 0;
  }
  .mint-cell-label {
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb !important;
    margin-left: -20px;
  }
  .owntext {
    padding: 0 !important;

    .van-field__control {
      height: 600px !important;
    }
    .van-field__word-limit {
      height: 75px;
      line-height: 75px;
      margin-bottom: 30px;
    }
  }
  .ownupload {
    margin: 0.5rem 0;
    .van-uploader__preview {
      margin: 10px 10px 10px 0;
      .van-image__error-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-image,
    .van-uploader__upload {
      width: 200px;
      height: 200px;
      border: 1px dashed #ccc;
      .van-uploader__upload-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-delete {
      width: 50px;
      height: 50px;
      .van-uploader__preview-delete-icon {
        font-size: 55px;
      }
    }
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 400px;
      font-size: 60px;
      height: 100px;
      line-height: 100px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .sub {
    width: 50%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
}
.system-pageAddD {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
.van-picker__toolbar {
  height: 1.586667rem;
}
.van-picker__cancel, .van-picker__confirm {
  padding: 0 0.213333rem;
  font-size: 1.186667rem;
}
.van-picker__title {
  font-size: 1.213333rem;
  line-height: 1.266667rem;
}
.van-picker-column__item {
  line-height: 1rem
}
.van-picker-column {
  font-size: .8rem;
}
.van-cell {
  font-size: 0.9rem;
  line-height: 1.32rem;
}
.van-field__control:read-only {
  font-size: .8rem;
}
</style>
